export default "__VITE_ASSET__e1657Y5A__"